import { Component, Input } from '@angular/core';
import { SegmentedTileModel } from 'libs/portal/src/modules/keepalive/models/SegmentedTile';

@Component({
  selector: 'app-segmented-data-tile',
  templateUrl: './segmented-data-tile.component.html',
  styleUrls: ['./segmented-data-tile.component.scss'],
})
export class SegmentedDataTileComponent {
  @Input() tileData: SegmentedTileModel[];
  segmentIndex = 0;

  constructor() {}
}
